module.exports = __webpack_public_path__ + "img/img-135.685232b8.png";